<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleCustomerId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              class="demo-ruleForm"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex">
                  <div class="flex min-w-32 font-bold">ID</div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.name" />
                  </div>
                </a-form-item>
                <a-form-item prop="phoneNum" testek="phoneNum" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.phoneNum" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="email" testek="email" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      Email
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.email" />
                  </div>
                </a-form-item>
                <a-form-item prop="contact" testek="Contact" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.contact" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="country" testek="country" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.country" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.City") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.city" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Address") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.address" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.postalCode" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && customer">
      <a-modal v-model:open="isShow" :closable="false" centered :width="800">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Customer") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="customer"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="customer.name" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="phoneNum" testek="phoneNum" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="customer.phoneNum" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="email" testek="email" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">Email</div>
                    <a-input v-model:value="customer.email" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="contact" testek="Contact" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                    </div>
                    <a-input v-model:value="customer.contact" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="country" testek="country" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                    </div>
                    <a-input v-model:value="customer.country" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.City") }}
                    </div>
                    <a-input v-model:value="customer.city" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Address") }}
                    </div>
                    <a-input v-model:value="customer.address" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                    </div>
                    <a-input v-model:value="customer.postalCode" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import { ModuleCustomer } from "@/store/module-const";
import _ from "lodash";
export default {
  name: "CustomerDetail",
  components: {
    BaseDetail,
  },
  props: {},
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditCustomer");
      return this.$t("i18nCommon.AddCustomer");
    },
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      contacts: [],
      statuses: [],
      currentItem: {},
      customer: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditCustomer", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditCustomer", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleCustomer, ["getCustomer", "createCustomer", "updateCustomer"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        name: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: "blur",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PhoneInvalid")}`,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: `${me.$t("i18nProduct.EmailInvalid")}`,
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CountryInvalid")}`,
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CityInvalid")}`,
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: `${me.$t("i18nProduct.AddressInvalid")}`,
            trigger: "blur",
          },
        ],
        contact: [
          {
            required: true,
            message: `${me.$t("i18nProduct.ContactInvalid")}`,
            trigger: "blur",
          },
        ],
        postalCode: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PostalCodeInvalid")}`,
            trigger: "blur",
          },
        ],
      };
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;
      setTimeout(async () => {
        let customer = await me.getCustomer({ id: payload.id });
        if (customer) {
          me.ruleForm = {
            id: customer.id,
            name: customer.name,
            phoneNum: customer.phoneNum,
            email: customer.email,
            country: customer.country,
            city: customer.city,
            address: customer.address,
            contact: customer.contact,
            postalCode: customer.postalCode,
            status: customer.status,
            type: customer.type,
            guest: customer.guest,
          };
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onChangeContact(payload) {
      const me = this;
      let contact = me.contacts.find((x) => x.id == payload);
      if (contact) {
        me.params.contact = contact.name;
      }
    },
    onChangeStatus(payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.params.status = status.status;
      }
    },
    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),

    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createCustomer(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddCustomerSuccess")
        );

        if (isReset == true) {
          me.ruleForm = {};
        }
        // me.$router.push("/product");
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddCustomerFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateCustomer(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditCustomerSuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditCustomerFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.customer = await me.getCustomer({ id: params.id });
      if (me.customer) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
